import React, { useState } from "react";
import { FaDesktop, FaMobile, FaTimes, FaClock, FaChartBar, FaBullhorn, FaPalette, FaComments, FaChartLine } from "react-icons/fa";
import { useCourseSelection } from "../../context/CourseSelectionContext";
import { useNavigate } from "react-router-dom";

const OurCourses = () => {
  const [expandedCourse, setExpandedCourse] = useState<number | null>(null);
  const [selectedPlans, setSelectedPlans] = useState<{[key: number]: number}>({});
  const { setSelectedCourse } = useCourseSelection();
  const navigate = useNavigate();

  const courses = [
    {
      id: 1,
      title: "Website - Full Stack Development",
      icon: <FaDesktop className="w-8 h-8" />,
      startingPrice: "₹3,999",
      description: "Comprehensive program covering front-end and back-end development with modern frameworks.",
      plans: [
        {
          name: "Basic",
          content: "HTML, CSS, JS, GIT BASICS, REACT BASICS",
          duration: "1 month",
          level: "Beginner",
          price: "₹3,999",
          isHighlighted: true
        },
        {
          name: "Standard",
          content: "BASIC PLAN + ADVANCED REACT with TS, Node JS (BASIC), API Integration",
          duration: "3 months",
          level: "Beginner to Intermediate",
          price: "₹9,999",
          isHighlighted: false
        },
        {
          name: "Advanced",
          content: "Full Stack (MERN), AWS Deployment & Capstone Project",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹19,999",
          isHighlighted: false
        }
      ]
    },
    {
      id: 2,
      title: "Mobile App Full Stack Development",
      icon: <FaMobile className="w-8 h-8" />,
      startingPrice: "₹3,999",
      description: "Build native and cross-platform mobile applications for iOS and Android with full stack capabilities.",
      plans: [
        {
          name: "Basic",
          content: "HTML, CSS, JS, GIT BASICS, REACT TS",
          duration: "1 month",
          level: "Beginner",
          price: "₹3,999",
          isHighlighted: true
        },
        {
          name: "Standard",
          content: "BASIC PLAN + ADVANCED REACT NATIVE (Android & iOS)",
          duration: "3 months",
          level: "Beginner to Intermediate",
          price: "₹9,999",
          isHighlighted: false
        },
        {
          name: "Advanced",
          content: "Full Stack (MERN + React Native), APP DEPLOYMENT",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹19,999",
          isHighlighted: false
        }
      ]
    },
    {
      id: 3,
      title: "Digital Marketing",
      icon: <FaBullhorn className="w-8 h-8" />,
      startingPrice: "₹4,999",
      description: "Master digital marketing strategies, social media marketing, and campaign management.",
      plans: [
        {
          name: "Basic",
          content: "SOCIAL MEDIA MARKETING, EMAIL MARKETING, CONTENT MARKETING",
          duration: "1 month",
          level: "Beginner",
          price: "₹4,999",
          isHighlighted: true
        },
        {
          name: "Standard",
          content: "BASIC PLAN + META ADS, INFLUENCER MARKETING & CAMPAIGN STRATEGY",
          duration: "3 months",
          level: "Beginner to Intermediate",
          price: "₹10,999",
          isHighlighted: false
        },
        {
          name: "Advanced",
          content: "BASIC PLAN + SALES, BRANDING, PROMOTIONS, AND PRICING",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹19,999",
          isHighlighted: false
        }
      ]
    },
    {
      id: 4,
      title: "Creative Designing",
      icon: <FaPalette className="w-8 h-8" />,
      startingPrice: "₹3,999",
      description: "Learn design fundamentals, UI/UX principles, and master creative tools for professional design work.",
      plans: [
        {
          name: "Basic",
          content: "INTRODUCTION TO FIGMA, CANVA, AND DESIGN FUNDAMENTALS",
          duration: "1 month",
          level: "Beginner",
          price: "₹3,999",
          isHighlighted: true
        },
        {
          name: "Standard",
          content: "FROM PS & AI BASICS TO ADVANCED DESIGN AND UI/UX INTERMEDIATE SKILLS",
          duration: "3 months",
          level: "Beginner to Intermediate",
          price: "₹7,999",
          isHighlighted: false
        },
        {
          name: "Advanced",
          content: "ADVANCED UI/UX: FIGMA, ADOBE & CASE STUDIES",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹14,999",
          isHighlighted: false
        }
      ]
    },
    {
      id: 5,
      title: "Communication Skills",
      icon: <FaComments className="w-8 h-8" />,
      startingPrice: "₹3,999",
      description: "Enhance your business communication skills and workplace English proficiency.",
      plans: [
        {
          name: "Basic",
          content: "FROM GRAMMAR TO SOFT SKILLS COMPLETE BUSINESS ENGLISH FOUNDATION",
          duration: "1 month",
          level: "Beginner",
          price: "₹3,999",
          isHighlighted: true
        },
        {
          name: "Advanced",
          content: "ADVANCED WORKPLACE ENGLISH + REAL WORLD DRILLS",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹7,499",
          isHighlighted: false
        }
      ]
    },
    {
      id: 6,
      title: "Data Science & Analytics",
      icon: <FaChartLine className="w-8 h-8" />,
      startingPrice: "₹9,999",
      description: "Complete career path from Data Analyst to Data Engineer to Data Scientist with comprehensive data skills.",
      plans: [
        {
          name: "Standard",
          content: "Excel (from basic to advanced), SQL (basic to intermediate), Introductory Statistics, Python Basics, Power BI Basics",
          duration: "3 months",
          level: "Beginner to Intermediate",
          price: "₹9,999",
          isHighlighted: true
        },
        {
          name: "Advanced",
          content: "Advanced Python, Data Engineering, Advanced SQL, Machine Learning & Deep Learning, Advanced Visualization (using Power BI & R), Optional Cloud Exposure",
          duration: "6 months",
          level: "Beginner to Advanced",
          price: "₹19,999",
          isHighlighted: false
        }
      ]
    }
  ];

  const toggleCourse = (courseId: number) => {
    setExpandedCourse(expandedCourse === courseId ? null : courseId);
  };

  const selectPlan = (courseId: number, planIndex: number) => {
    setSelectedPlans(prev => ({
      ...prev,
      [courseId]: planIndex
    }));

    // Update the context with selected course and plan
    const course = courses.find(c => c.id === courseId);
    if (course) {
      setSelectedCourse({
        id: course.id,
        title: course.title,
        selectedPlan: course.plans[planIndex]
      });
    }
  };

  const handleEnrollNow = (courseId: number) => {
    const selectedPlanIndex = selectedPlans[courseId];
    if (selectedPlanIndex !== undefined) {
      selectPlan(courseId, selectedPlanIndex);
      // Scroll to contact form section
      const contactSection = document.getElementById('contact-form');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If no plan selected, select the first plan (Basic)
      selectPlan(courseId, 0);
      // Scroll to contact form section
      const contactSection = document.getElementById('contact-form');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleExploreCourses = () => {
    const coursesSection = document.getElementById('our-courses');
    if (coursesSection) {
      coursesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="our-courses" className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
            Our Courses
            <div className="w-24 h-1 bg-blue-600 mx-auto mt-2"></div>
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-3xl mx-auto">
            Choose from our comprehensive selection of technology courses designed to advance your career and build in-demand skills.
          </p>
        </div>

        {/* Courses */}
        <div className="space-y-6">
          {courses.map((course) => (
            <div key={course.id} className="bg-gray-50 rounded-lg shadow-lg overflow-hidden">
              {expandedCourse === course.id ? (
                /* Expanded Course Card */
                <div className="p-6">
                  {/* Course Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                      <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white mr-4">
                        {course.icon}
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900">{course.title}</h3>
                        <p className="text-gray-600">{course.description}</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setExpandedCourse(null)}
                      className="text-gray-400 hover:text-gray-600 transition duration-300"
                    >
                      <FaTimes className="w-6 h-6" />
                    </button>
                  </div>

                  {/* Separator */}
                  <div className="w-full h-1 bg-blue-600 mb-6"></div>

                  {/* Course Plans */}
                  <div className="space-y-4 mb-6">
                    {course.plans.map((plan, index) => {
                      const isSelected = selectedPlans[course.id] === index;
                      return (
                        <div
                          key={index}
                          onClick={() => selectPlan(course.id, index)}
                          className={`p-4 rounded-lg cursor-pointer transition-all duration-300 ${
                            isSelected
                              ? "bg-blue-600 text-white border-2 border-blue-700"
                              : "bg-white border border-gray-200 hover:border-blue-300"
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <h4 className={`font-bold text-lg mb-2 ${
                                isSelected ? "text-white" : "text-gray-900"
                              }`}>
                                {plan.name}
                              </h4>
                              <p className={`mb-3 ${
                                isSelected ? "text-white" : "text-gray-700"
                              }`}>
                                {plan.content}
                              </p>
                              <div className="flex items-center space-x-4 text-sm">
                                <div className={`flex items-center ${
                                  isSelected ? "text-white" : "text-gray-500"
                                }`}>
                                  <FaClock className={`w-4 h-4 mr-1 ${
                                    isSelected ? "text-white" : "text-blue-600"
                                  }`} />
                                  {plan.duration}
                                </div>
                                <div className={`flex items-center ${
                                  isSelected ? "text-white" : "text-gray-500"
                                }`}>
                                  <FaChartBar className={`w-4 h-4 mr-1 ${
                                    isSelected ? "text-white" : "text-blue-600"
                                  }`} />
                                  {plan.level}
                                </div>
                              </div>
                            </div>
                            <div className="text-right">
                              <div className={`font-bold text-lg ${
                                isSelected ? "text-white" : "text-blue-600"
                              }`}>
                                {plan.price}
                              </div>
                              <div className={`text-sm ${
                                isSelected ? "text-white" : "text-gray-500"
                              }`}>
                                /course
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Enroll Now Button */}
                  <button 
                    onClick={() => handleEnrollNow(course.id)}
                    className="w-full bg-blue-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-300"
                  >
                    Enroll Now
                  </button>
                </div>
              ) : (
                /* Collapsed Course Card */
                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white mr-4">
                        {course.icon}
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-gray-900">{course.title}</h3>
                        <p className="text-gray-600">{course.description}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-sm text-gray-500 mb-1">Starting From</div>
                      <div className="text-2xl font-bold text-blue-600 mb-4">
                        {course.startingPrice}
                        <span className="text-sm font-normal text-gray-500">/course</span>
                      </div>
                      <button
                        onClick={() => toggleCourse(course.id)}
                        className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition duration-300"
                      >
                        More Info
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurCourses;


